//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server, imageUrl } from "@/services/constants";
import SuccessDialog from "@/components/cards/SuccessDialog";
import { Loader } from "@googlemaps/js-api-loader";
import moment from "moment";

// [LOCATION FIX] ค่าคงที่สำหรับการหาตำแหน่ง
const DEFAULT_LAT_LNG = { lat: 13.7563, lng: 100.5018 };
const LOCATION_REFRESH_MS = 5 * 60 * 1000; // รีเฟรชพิกัดทุก 5 นาที
const LOCATION_MAX_AGE_FOR_CHECKIN_MS = 10 * 60 * 1000; // ใช้พิกัดเดิมได้ถ้าไม่เก่ากว่า 10 นาที
const COORD_DECIMALS = 6; // ~0.1 เมตร (เดิม toFixed(4) ~11 เมตร)

export default {
  name: "Dashboard",
  data() {
    return {
      sec_acc_my_time_off: false,
      sec_acc_approve_time_off: false,
      sec_acc_time_attendance: false,
      sec_acc_out_of_office: false,
      sec_acc_list: [],

      leave_list: [],
      leave_number: "0",
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      th_name: "",
      eng_name: "",
      worker_time: "",
      sick_day: 0,
      sick_hours: 0.0,
      vacation_day: 0,
      pending_cont: 0,
      vacation_hours: 0.0,
      leavehistory_list: [],
      leaveHistoryAll: [], // ประวัติการลาทั้งหมดของผู้ใช้ (ใช้ทำ Upcoming time off)
      leaveApprove_list: [],
      approvePendingTotal: 0, // จำนวนรายการรออนุมัติทั้งหมดจาก API
      datenow_show: null,
      timenow_show: null,
      expecttime: null,
      statusActivity: "",
      checkindate: null,
      dialogcCheckIn: false,
      currentTime: "",
      dataActivivty: {},
      duration: 0,
      update_id: 0,
      location_lat: null,
      location_lng: null,
      wasDenied: false,
      map: null,
      marker: null,
      loaderInstance: null,
      isLocating: false,

      // [LOCATION FIX] state เพิ่มเติม
      location_accuracy: null, // ความแม่นยำ (เมตร)
      location_updated_at: null, // เวลาที่ได้พิกัดล่าสุด (ms)
      locationError: "", // ข้อความ error ล่าสุด แสดงใต้แผนที่
      locationRequest: null, // promise ที่กำลังขอพิกัดอยู่ (กันขอซ้อน)
      mapSetupPromise: null, // promise ที่กำลังสร้างแผนที่อยู่ (กันสร้างซ้อน)
      mapLoadFailed: false,
      mapInterval: null,
      geoPermissionStatus: null,

      // [LOCATION FIX] popup แจ้งปัญหาตำแหน่ง
      locationErrorReason: "",
      locationDialog: false,
      locationDialogData: {
        title: "",
        icon: "",
        color: "",
        message: "",
        sections: [],
        showRetry: false,
        retryLabel: "ลองใหม่",
        retryAction: "location",
        showCopyLink: false,
      },
      copyLinkDone: false,
      mapErrorShown: false,
    };
  },
  components: {
    SuccessDialog,
  },
  computed: {
    // ข้อความทักทายตามช่วงเวลา (อ้างอิง currentTime เพื่อให้อัปเดตทุกนาที)
    greetingText() {
      // eslint-disable-next-line no-unused-expressions
      this.currentTime;
      const h = new Date().getHours();
      if (h < 12) return "Good morning";
      if (h < 18) return "Good afternoon";
      return "Good evening";
    },
    // วันที่เต็ม เช่น Wednesday, 24 September 2026
    todayLongText() {
      // eslint-disable-next-line no-unused-expressions
      this.currentTime;
      return new Date().toLocaleDateString("en-GB", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    // ใช้ชื่ออังกฤษก่อน ถ้าไม่มีใช้ชื่อไทย (เหมือนเงื่อนไขเดิม)
    displayName() {
      const en = (this.eng_name || "").trim();
      return en ? en : this.th_name || "";
    },
    userInitials() {
      return this.getInitials(this.displayName);
    },
    // จำนวนรายการที่ยังรออนุมัติ (จากรายการที่โหลดมาแสดง)
    // ประเภทหน้าจอ: มีสิทธิ์อนุมัติ (SEC-001) = Approver Dashboard, ไม่มี = Employee Dashboard
    isApproverView() {
      return this.sec_acc_approve_time_off;
    },
    isEmployeeView() {
      return !this.sec_acc_approve_time_off;
    },
    // วันลาที่อนุมัติแล้ว (status 3) และเริ่มภายใน 30 วันข้างหน้า (รวมวันลาที่กำลังลาอยู่)
    upcomingLeaves() {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const limit = new Date(today);
      limit.setDate(limit.getDate() + 30);

      return (this.leaveHistoryAll || [])
        .filter((item) => {
          if (Number(item.status) !== 3) return false;
          const start = this.parseLeaveDate(this.leaveStartRaw(item));
          const end = this.parseLeaveDate(this.leaveEndRaw(item)) || start;
          if (!start) return false;
          return end >= today && start <= limit;
        })
        .sort(
          (a, b) =>
            this.parseLeaveDate(this.leaveStartRaw(a)) - this.parseLeaveDate(this.leaveStartRaw(b)),
        )
        .slice(0, 5);
    },
    pendingApproveCount() {
      return this.approvePendingTotal;
    },
  },
  async mounted() {
    try {
      await api.checkVersion();

      const userId = localStorage.getItem(server.USER_ID);
      if (!userId || !api.isLoggedIn()) {
        this.$store.state.isLogged = false;
        this.$router.push("/login");
        return;
      }

      localStorage.setItem(server.MODELMENU, 0);

      // [LOCATION FIX] ต้องรู้สิทธิ์ section ก่อน เพื่อให้ <div id="map"> ถูก render
      // ก่อนที่ loadActivityData จะเรียก initMap (แก้ race condition)
      await this.getSectionData();

      // โหลดข้อมูลทั้งหมด
      await Promise.all([
        this.loadActivityData(),
        this.loadEmpdata(),
        this.loadQuota(),
        this.loadleaveHistory(),
        this.loadleaveApprove(),
        this.loadLeave(),
      ]);

      this.$hideLoader();

      // ตั้ง interval
      setInterval(this.updateTime, 1000);
      // [LOCATION FIX] เก็บ id ไว้ clear ตอนออกจากหน้า และรีเฟรชแบบเงียบ (ไม่เด้ง dialog ซ้ำทุก 5 นาที)
      this.mapInterval = setInterval(
        () => this.initMap({ silent: true }),
        LOCATION_REFRESH_MS,
      );

      // [LOCATION FIX] เฝ้าดูการเปลี่ยนสิทธิ์ location (มี try/catch กัน Safari รุ่นเก่า)
      await this.watchGeoPermission();
    } catch (error) {
      this.$hideLoader();
    }
  },
  beforeDestroy() {
    // [LOCATION FIX] เคลียร์ interval และ listener ของ location เมื่อออกจากหน้า
    if (this.mapInterval) {
      clearInterval(this.mapInterval);
      this.mapInterval = null;
    }
    if (this.geoPermissionStatus) {
      this.geoPermissionStatus.onchange = null;
      this.geoPermissionStatus = null;
    }
  },
  methods: {
    // ===== UI helpers (ใช้แสดงผลอย่างเดียว ไม่กระทบการทำงานเดิม) =====
    getInitials(name) {
      const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
      if (parts.length === 0) return "?";
      if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    },
    avatarColor(index) {
      const palette = [
        { bg: "#E8EEFB", fg: "#3B5BDB" },
        { bg: "#E6F6EE", fg: "#2F9E44" },
        { bg: "#E8F3FB", fg: "#1C7ED6" },
        { bg: "#FDECEC", fg: "#E03131" },
        { bg: "#F1E8FB", fg: "#7048E8" },
      ];
      return palette[index % palette.length];
    },
    leaveTypeIcon(type) {
      const t = String(type || "").toLowerCase();
      if (t.includes("sick")) return { icon: "mdi-stethoscope", color: "#E5534B" };
      if (t.includes("vacation")) return { icon: "mdi-palm-tree", color: "#3E87BE" };
      return { icon: "mdi-calendar-blank-outline", color: "#6B7280" };
    },
    formatLeaveDuration(hoursAmount) {
      const total = Number(hoursAmount) || 0;
      const d = Math.floor(total / 8);
      const h = Number((total - d * 8).toFixed(2));
      const parts = [];
      if (d > 0) parts.push(`${d} ${d === 1 ? "day" : "days"}`);
      if (h > 0) parts.push(`${h} ${h === 1 ? "hour" : "hours"}`);
      return parts.length ? parts.join(" ") : "-";
    },
    // ===== Upcoming time off helpers (รองรับหลายชื่อ field จาก API) =====
    leaveStartRaw(item) {
      return item.startDate || item.startdate || item.start_date || item.data_date || null;
    },
    leaveEndRaw(item) {
      return item.endDate || item.enddate || item.end_date || null;
    },
    parseLeaveDate(value) {
      if (!value) return null;
      // รองรับ DD/MM/YYYY
      if (typeof value === "string" && /^\d{2}\/\d{2}\/\d{4}/.test(value)) {
        const [d, m, y] = value.substring(0, 10).split("/");
        return new Date(Number(y), Number(m) - 1, Number(d));
      }
      const dt = moment(value);
      if (!dt.isValid()) return null;
      return new Date(dt.year(), dt.month(), dt.date());
    },
    upcomingDateText(item) {
      const start = this.parseLeaveDate(this.leaveStartRaw(item));
      const end = this.parseLeaveDate(this.leaveEndRaw(item));
      if (!start) return "-";
      const fmt = (d) => moment(d).format("D MMM YYYY");
      if (!end || end.getTime() === start.getTime()) return fmt(start);
      return `${fmt(start)} - ${fmt(end)}`;
    },
    // จำนวนชั่วโมงลา: ใช้ hours_amount ถ้ามี ไม่งั้นแปลงจาก amount (นาที)
    upcomingHours(item) {
      if (item.hours_amount !== undefined && item.hours_amount !== null && item.hours_amount !== "") {
        return Number(item.hours_amount);
      }
      return Number(item.amount || 0) / 60;
    },
    // ชื่อพนักงานในรายการอนุมัติ (รองรับหลายชื่อ field จาก API)
    approveEmployeeName(item) {
      const en = String(item.name_eng || "").trim();
      const th = String(item.name_th || "").trim();
      return en || th || "-";
    },
    // วันที่ลา: ใช้ str_time / end_time (YYYY-MM-DD) แสดงเป็น 9 Sep 2026 หรือช่วงวันที่
    approveDateText(item) {
      const start = item.str_time ? moment(item.str_time, "YYYY-MM-DD") : null;
      const end = item.end_time ? moment(item.end_time, "YYYY-MM-DD") : null;
      if (!start || !start.isValid()) return item.data_date || "-";
      if (!end || !end.isValid() || end.isSame(start, "day")) {
        return start.format("D MMM YYYY");
      }
      if (start.isSame(end, "month")) {
        return `${start.format("D")} - ${end.format("D MMM YYYY")}`;
      }
      return `${start.format("D MMM")} - ${end.format("D MMM YYYY")}`;
    },
    async getSectionData() {
      const result = await api.getSectionAccessConfig_By_CompanyID(
        localStorage.getItem(server.COMPANYID),
      );

      let my_positions_id = parseInt(localStorage.getItem(server.POSITION_ID));

      // ตั้งค่าเริ่มต้น
      this.sec_acc_approve_time_off = false;
      this.sec_acc_my_time_off = false;
      this.sec_acc_time_attendance = false;
      this.sec_acc_out_of_office = false;

      // ✅ เช็คว่า result.data มีข้อมูลก่อน
      if (!result.data || result.data.length === 0) {
        this.$hideLoader();
        return;
      }

      for (const section of result.data) {
        // ✅ เช็คว่า section_id มีค่า
        if (!section.section_id) {
          continue;
        }

        // ✅ เช็คว่า position_id เป็น array
        if (!Array.isArray(section.position_id)) {
          continue;
        }

        const hasAccess = section.position_id.includes(
          my_positions_id.toString(),
        );

        switch (section.section_id) {
          case "SEC-001":
            this.sec_acc_approve_time_off = hasAccess;
            break;
          case "SEC-002":
            this.sec_acc_my_time_off = hasAccess;
            break;
          case "SEC-003":
            this.sec_acc_time_attendance = hasAccess;
            break;
          case "SEC-004":
            this.sec_acc_out_of_office = hasAccess;
            break;
          default:
            break;
        }
      }

      this.sec_acc_list = result.data;
      this.$hideLoader();
    },

    // =====================================================================
    // [LOCATION FIX] ส่วนจัดการตำแหน่งทั้งหมด
    // =====================================================================

    // แปลงค่าพิกัดจาก API (อาจเป็น string / null / undefined) ให้เป็น number หรือ null
    toCoord(value) {
      if (value === null || value === undefined || value === "") return null;
      const n = Number(value);
      return Number.isFinite(n) ? n : null;
    },

    isValidCoords(lat, lng) {
      return (
        Number.isFinite(lat) &&
        Number.isFinite(lng) &&
        lat >= -90 &&
        lat <= 90 &&
        lng >= -180 &&
        lng <= 180 &&
        !(lat === 0 && lng === 0) // 0,0 มักเป็นค่าเสียจากอุปกรณ์
      );
    },

    // เช็ค permission แบบปลอดภัย (บางเบราว์เซอร์ query แล้ว throw)
    async isGeoPermissionDenied() {
      if (!navigator.permissions || !navigator.permissions.query) return false;
      try {
        const status = await navigator.permissions.query({ name: "geolocation" });
        return status.state === "denied";
      } catch (e) {
        return false;
      }
    },

    async watchGeoPermission() {
      if (!navigator.permissions || !navigator.permissions.query) return;
      try {
        const status = await navigator.permissions.query({ name: "geolocation" });
        this.geoPermissionStatus = status;
        this.wasDenied = status.state === "denied";

        status.onchange = () => {
          if (status.state === "granted" && (this.wasDenied || this.location_lat === null)) {
            // ผู้ใช้เพิ่งเปิดสิทธิ์: ขอพิกัดใหม่ทันที ไม่ต้อง reload หน้า
            this.wasDenied = false;
            this.initMap();
          } else if (status.state === "denied") {
            this.wasDenied = true;
            if (this.statusActivity !== "checkout") {
              this.location_lat = null;
              this.location_lng = null;
              this.location_updated_at = null;
            }
          }
        };
      } catch (e) {
        // เบราว์เซอร์ไม่รองรับ query geolocation: ข้ามไป
      }
    },

    // ครอบ getCurrentPosition ด้วย timeout ของเราเอง
    // เพราะ option timeout ของเบราว์เซอร์ไม่นับเวลาที่รอผู้ใช้กด Allow/Block
    getPosition(options, hardTimeoutMs) {
      return new Promise((resolve, reject) => {
        let done = false;
        const timer = setTimeout(() => {
          if (done) return;
          done = true;
          reject({ code: 3, hardTimeout: true });
        }, hardTimeoutMs);

        navigator.geolocation.getCurrentPosition(
          (pos) => {
            if (done) return;
            done = true;
            clearTimeout(timer);
            resolve(pos);
          },
          (err) => {
            if (done) return;
            done = true;
            clearTimeout(timer);
            reject(err);
          },
          options,
        );
      });
    },

    // ลองแบบแม่นยำสูงก่อน (GPS) ถ้าไม่ได้ค่อย fallback เป็นแบบ Wi-Fi/เครือข่าย
    async getBestPosition(fresh) {
      try {
        return await this.getPosition(
          { enableHighAccuracy: true, timeout: 10000, maximumAge: fresh ? 0 : 60000 },
          30000,
        );
      } catch (err) {
        // ถูกปฏิเสธ หรือผู้ใช้ไม่ตอบ prompt: ไม่ต้องลองซ้ำ
        if (err && (err.code === 1 || err.hardTimeout)) throw err;
        return await this.getPosition(
          { enableHighAccuracy: false, timeout: 10000, maximumAge: fresh ? 30000 : 300000 },
          15000,
        );
      }
    },

    // ขอพิกัดปัจจุบัน (ไม่ผูกกับการโหลดแผนที่) คืน {lat,lng} หรือ null
    fetchCurrentLocation({ silent = false, fresh = false } = {}) {
      if (this.locationRequest) return this.locationRequest;

      this.locationRequest = (async () => {
        try {
          this.locationError = "";

          if (!window.isSecureContext) {
            return this.handleLocationError("insecure", silent);
          }
          if (!navigator.geolocation) {
            return this.handleLocationError("unsupported", silent);
          }
          if (await this.isGeoPermissionDenied()) {
            return this.handleLocationError("denied", silent);
          }

          this.isLocating = true;
          const pos = await this.getBestPosition(fresh);

          const lat = Number(pos.coords.latitude.toFixed(COORD_DECIMALS));
          const lng = Number(pos.coords.longitude.toFixed(COORD_DECIMALS));
          if (!this.isValidCoords(lat, lng)) {
            return this.handleLocationError("invalid", silent);
          }

          this.location_lat = lat;
          this.location_lng = lng;
          this.location_accuracy = Math.round(pos.coords.accuracy);
          this.location_updated_at = Date.now();
          this.updateMapView();
          return { lat, lng };
        } catch (err) {
          const code = err && err.code;
          let reason = "unknown";
          if (code === 1) reason = "denied";
          else if (code === 2) reason = "unavailable";
          else if (code === 3) reason = err.hardTimeout ? "prompt" : "timeout";
          return this.handleLocationError(reason, silent);
        } finally {
          this.isLocating = false;
          this.locationRequest = null;
        }
      })();

      return this.locationRequest;
    },

    handleLocationError(reason, silent) {
      const env = this.detectBrowserEnv();

      // เปิดผ่านแอป LINE / Facebook / Instagram มักใช้ตำแหน่งไม่ได้ ให้แนะนำเปิดในเบราว์เซอร์แทน
      if (env.isInApp && ["denied", "unavailable", "unsupported", "timeout", "prompt"].includes(reason)) {
        reason = "inapp";
      }

      const info = this.getLocationErrorInfo(reason, env);
      this.locationErrorReason = reason;
      this.locationError = info.title;

      // เคสที่รู้แน่ว่าพิกัดเดิมใช้ไม่ได้แล้ว ให้ล้างทิ้ง
      if (["denied", "insecure", "unsupported", "inapp"].includes(reason)) {
        this.location_lat = null;
        this.location_lng = null;
        this.location_updated_at = null;
      }

      if (!silent) {
        this.showLocationDialog(reason);
      }
      return null;
    },

    // ---------- popup แจ้งปัญหาตำแหน่ง ----------

    showLocationDialog(reason) {
      const env = this.detectBrowserEnv();
      this.locationDialogData = this.getLocationErrorInfo(reason, env);
      this.copyLinkDone = false;
      this.locationDialog = true;
    },

    closeLocationDialog() {
      this.locationDialog = false;
    },

    retryLocationFromDialog() {
      const action = this.locationDialogData.retryAction;
      this.locationDialog = false;

      if (action === "reload") {
        window.location.reload();
        return;
      }
      if (action === "https") {
        window.location.href = window.location.href.replace(/^http:/, "https:");
        return;
      }
      this.initMap();
    },

    async copyPageLink() {
      const url = window.location.href;
      try {
        await navigator.clipboard.writeText(url);
      } catch (e) {
        const ta = document.createElement("textarea");
        ta.value = url;
        document.body.appendChild(ta);
        ta.select();
        try {
          document.execCommand("copy");
        } catch (err) {
          // คัดลอกไม่ได้: ผู้ใช้ต้องคัดลอกเอง
        }
        document.body.removeChild(ta);
      }
      this.copyLinkDone = true;
    },

    detectBrowserEnv() {
      const ua = navigator.userAgent || "";
      const isIOS =
        /iPad|iPhone|iPod/.test(ua) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
      const isAndroid = /Android/i.test(ua);
      const isMac = !isIOS && /Macintosh|Mac OS X/.test(ua);
      const isWindows = /Windows/i.test(ua);

      // ลำดับสำคัญ: Edge / Samsung / Opera มีคำว่า Chrome ใน UA ด้วย ต้องเช็คก่อน
      let browser = "other";
      if (/\bLine\//i.test(ua)) browser = "line";
      else if (/FBAN|FBAV|FB_IAB|Instagram/i.test(ua)) browser = "facebook";
      else if (/SamsungBrowser/i.test(ua)) browser = "samsung";
      else if (/Edg(A|iOS)?\//i.test(ua)) browser = "edge";
      else if (/OPR\/|Opera/i.test(ua)) browser = "opera";
      else if (/Firefox|FxiOS/i.test(ua)) browser = "firefox";
      else if (/Chrome|CriOS/i.test(ua)) browser = "chrome";
      else if (/Safari/i.test(ua)) browser = "safari";

      const os = isIOS ? "ios" : isAndroid ? "android" : isMac ? "mac" : isWindows ? "windows" : "other";

      return { os, browser, isInApp: browser === "line" || browser === "facebook" };
    },

    getBrowserName(env) {
      const names = {
        chrome: "Google Chrome",
        edge: "Microsoft Edge",
        firefox: "Firefox",
        safari: "Safari",
        samsung: "Samsung Internet",
        opera: "Opera",
        line: "LINE",
        facebook: "Facebook / Instagram",
        other: "เบราว์เซอร์",
      };
      return names[env.browser] || names.other;
    },

    // วิธีเปิดสิทธิ์ตำแหน่งในเบราว์เซอร์ แยกตามเบราว์เซอร์และระบบ
    getBrowserPermissionSteps(env) {
      const name = this.getBrowserName(env);
      const host = window.location.host;

      if (env.os === "ios") {
        if (env.browser === "safari") {
          return [
            'เปิดแอป "ตั้งค่า" (Settings) > "ความเป็นส่วนตัวและความปลอดภัย" (Privacy & Security) > "บริการหาตำแหน่ง" (Location Services) แล้วเปิดสวิตช์',
            'เลื่อนลงไปที่ "เว็บไซต์ Safari" (Safari Websites) แล้วเลือก "ขณะใช้แอป" (While Using the App)',
            'กลับมาที่ Safari แตะปุ่ม "aA" ด้านซ้ายของช่อง URL > "การตั้งค่าเว็บไซต์" (Website Settings) > "ตำแหน่ง" (Location) > "อนุญาต" (Allow)',
            'โหลดหน้านี้ใหม่ แล้วกด "อนุญาต" เมื่อระบบถาม',
          ];
        }
        return [
          'เปิดแอป "ตั้งค่า" (Settings) > "ความเป็นส่วนตัวและความปลอดภัย" (Privacy & Security) > "บริการหาตำแหน่ง" (Location Services) แล้วเปิดสวิตช์',
          `เลื่อนหา "${name}" แล้วเลือก "ขณะใช้แอป" (While Using the App)`,
          `กลับมาที่ ${name} โหลดหน้านี้ใหม่ แล้วกด "อนุญาต" เมื่อระบบถาม`,
        ];
      }

      if (env.os === "android") {
        if (env.browser === "samsung") {
          return [
            'แตะเมนู ≡ มุมขวาล่าง > "การตั้งค่า" (Settings) > "เว็บไซต์และการดาวน์โหลด" (Sites and downloads) > "สิทธิ์ของเว็บไซต์" (Site permissions) > "ตำแหน่ง" (Location)',
            `เลือก ${host} แล้วเปลี่ยนเป็น "อนุญาต" (Allow)`,
            'โหลดหน้านี้ใหม่ แล้วกด "อนุญาต" เมื่อระบบถาม',
          ];
        }
        if (env.browser === "firefox") {
          return [
            'แตะ ⋮ > "การตั้งค่า" (Settings) > "สิทธิ์ของไซต์" (Site permissions) > "ตำแหน่ง" (Location)',
            'เลือก "ถามเพื่ออนุญาต" (Ask to allow) และลบการบล็อกของเว็บนี้',
            'โหลดหน้านี้ใหม่ แล้วกด "อนุญาต" เมื่อระบบถาม',
          ];
        }
        return [
          'แตะไอคอนด้านซ้ายของช่อง URL > "สิทธิ์" (Permissions) > "ตำแหน่ง" (Location) แล้วเปิด',
          `หรือแตะ ⋮ > "การตั้งค่า" (Settings) > "การตั้งค่าเว็บไซต์" (Site settings) > "ตำแหน่ง" (Location) แล้วเอา ${host} ออกจากรายการ "ถูกบล็อก" (Blocked)`,
          'โหลดหน้านี้ใหม่ แล้วกด "อนุญาต" เมื่อระบบถาม',
        ];
      }

      // Desktop
      switch (env.browser) {
        case "chrome":
          return [
            "คลิกไอคอนด้านซ้ายของช่อง URL (ไอคอนแม่กุญแจหรือไอคอนปรับแต่ง)",
            'เปิดสวิตช์ "ตำแหน่ง" (Location) หรือเลือก "การตั้งค่าเว็บไซต์" (Site settings) > "ตำแหน่ง" > "อนุญาต" (Allow)',
            `หากไม่พบ ให้พิมพ์ chrome://settings/content/location ในช่อง URL แล้วลบ ${host} ออกจากรายการ "ไม่อนุญาต" (Not allowed)`,
            "โหลดหน้านี้ใหม่ (กด F5)",
          ];
        case "edge":
          return [
            "คลิกไอคอนแม่กุญแจด้านซ้ายของช่อง URL",
            'เลือก "สิทธิ์สำหรับไซต์นี้" (Permissions for this site) > "ตำแหน่ง" (Location) > "อนุญาต" (Allow)',
            `หากไม่พบ ให้พิมพ์ edge://settings/content/location ในช่อง URL แล้วลบ ${host} ออกจากรายการ "บล็อก" (Block)`,
            "โหลดหน้านี้ใหม่ (กด F5)",
          ];
        case "opera":
          return [
            "คลิกไอคอนด้านซ้ายของช่อง URL แล้วเปิดสิทธิ์ตำแหน่ง (Location)",
            `หากไม่พบ ให้พิมพ์ opera://settings/content/location แล้วลบ ${host} ออกจากรายการที่บล็อก`,
            "โหลดหน้านี้ใหม่ (กด F5)",
          ];
        case "firefox":
          return [
            "คลิกไอคอนด้านซ้ายของช่อง URL",
            'ที่รายการ "เข้าถึงตำแหน่งของคุณ" (Access your location) ซึ่งแสดงว่าบล็อกอยู่ ให้กด ✕ เพื่อล้างการบล็อก',
            'โหลดหน้านี้ใหม่ แล้วกด "อนุญาต" (Allow) เมื่อระบบถาม',
          ];
        case "safari":
          return [
            'ที่แถบเมนูด้านบน เลือก Safari > "การตั้งค่า" (Settings) > แท็บ "เว็บไซต์" (Websites)',
            `เลือก "ตำแหน่ง" (Location) ด้านซ้าย แล้วตั้ง ${host} เป็น "อนุญาต" (Allow)`,
            "โหลดหน้านี้ใหม่",
          ];
        default:
          return [
            "เปิดการตั้งค่าของเบราว์เซอร์ > การตั้งค่าเว็บไซต์ / สิทธิ์ > ตำแหน่ง (Location)",
            `อนุญาตให้ ${host} เข้าถึงตำแหน่ง`,
            "โหลดหน้านี้ใหม่",
          ];
      }
    },

    // วิธีเปิดบริการตำแหน่งระดับเครื่อง (OS)
    getOsLocationSteps(env) {
      const name = this.getBrowserName(env);
      switch (env.os) {
        case "windows":
          return [
            'กด Windows + I เพื่อเปิด "การตั้งค่า" (Settings) > "ความเป็นส่วนตัวและความปลอดภัย" (Privacy & security) > "ตำแหน่ง" (Location)',
            'เปิด "บริการตำแหน่ง" (Location services)',
            'เปิด "ให้แอปเข้าถึงตำแหน่งของคุณ" และ "ให้แอปเดสก์ท็อปเข้าถึงตำแหน่งของคุณ" (Let desktop apps access your location)',
          ];
        case "mac":
          return [
            'เมนู Apple > "การตั้งค่าระบบ" (System Settings) > "ความเป็นส่วนตัวและความปลอดภัย" (Privacy & Security) > "บริการหาตำแหน่ง" (Location Services)',
            `เปิดสวิตช์ "บริการหาตำแหน่ง" และเปิดสวิตช์ของ ${name}`,
            `ปิดแล้วเปิด ${name} ใหม่ แล้วเข้าหน้านี้อีกครั้ง`,
          ];
        case "android":
          return [
            'ปัดแถบด้านบนของจอลง แล้วเปิด "ตำแหน่ง" (Location)',
            `ไปที่ "การตั้งค่า" (Settings) > "แอป" (Apps) > ${name} > "สิทธิ์" (Permissions) > "ตำแหน่ง" (Location) > "อนุญาตเฉพาะขณะใช้แอป"`,
            'เปิด "ใช้ตำแหน่งที่แม่นยำ" (Use precise location)',
          ];
        case "ios":
          return [
            'เปิดแอป "ตั้งค่า" (Settings) > "ความเป็นส่วนตัวและความปลอดภัย" > "บริการหาตำแหน่ง" แล้วเปิดสวิตช์',
            `เลือก ${env.browser === "safari" ? '"เว็บไซต์ Safari"' : name} > "ขณะใช้แอป" และเปิด "ตำแหน่งที่แม่นยำ" (Precise Location)`,
          ];
        default:
          return ['เปิดบริการตำแหน่ง (Location) ในการตั้งค่าของเครื่อง'];
      }
    },

    // ข้อมูล popup ของแต่ละเคส
    getLocationErrorInfo(reason, env) {
      const name = this.getBrowserName(env);
      const base = {
        icon: "mdi-map-marker-alert-outline",
        color: "#ff4f45",
        sections: [],
        showRetry: true,
        retryLabel: "ลองใหม่",
        retryAction: "location",
        showCopyLink: false,
      };

      switch (reason) {
        case "denied":
          return {
            ...base,
            icon: "mdi-map-marker-off-outline",
            title: `ยังไม่ได้เปิดสิทธิ์ตำแหน่งใน ${name}`,
            message: `ต้องใช้ตำแหน่งของคุณในการเช็คอิน แต่ ${name} บล็อกการเข้าถึงตำแหน่งของเว็บนี้อยู่`,
            sections: [
              { title: `วิธีเปิดสิทธิ์ใน ${name}`, steps: this.getBrowserPermissionSteps(env) },
              ...(env.os === "ios"
                ? []
                : [{ title: "หากเปิดแล้วยังไม่ได้ ให้ตรวจสอบการตั้งค่าเครื่อง", steps: this.getOsLocationSteps(env) }]),
            ],
          };

        case "prompt":
          return {
            ...base,
            icon: "mdi-map-marker-question-outline",
            color: "#ffbe5c",
            title: "รอการอนุญาตเข้าถึงตำแหน่ง",
            message: `${name} ขออนุญาตใช้ตำแหน่งของคุณ แต่ยังไม่ได้รับการตอบกลับ`,
            sections: [
              {
                title: "วิธีอนุญาต",
                steps: [
                  "มองหาหน้าต่างขออนุญาต หรือไอคอนตำแหน่งที่มีขีดฆ่าในช่อง URL",
                  'กด "อนุญาต" (Allow) หรือ "อนุญาตขณะเข้าชมไซต์" (Allow while visiting the site)',
                  'หากไม่เห็นหน้าต่าง ให้กด "ลองใหม่" ด้านล่าง',
                ],
              },
            ],
          };

        case "unavailable":
          return {
            ...base,
            icon: "mdi-crosshairs-off",
            title: "เครื่องยังระบุตำแหน่งไม่ได้",
            message: `${name} ได้รับสิทธิ์แล้ว แต่เครื่องหาตำแหน่งไม่ได้ มักเกิดจากยังไม่ได้เปิดบริการตำแหน่งของเครื่อง`,
            sections: [
              { title: "เปิดบริการตำแหน่งของเครื่อง", steps: this.getOsLocationSteps(env) },
              {
                title: "ถ้ายังไม่ได้",
                steps: [
                  "เปิด Wi-Fi (แม้ไม่ได้เชื่อมต่อ ก็ช่วยให้ระบุตำแหน่งได้)",
                  "ปิด VPN หรือโปรแกรมเปลี่ยน IP ชั่วคราว",
                ],
              },
            ],
          };

        case "timeout":
          return {
            ...base,
            icon: "mdi-timer-sand",
            color: "#ffbe5c",
            title: "ค้นหาตำแหน่งนานเกินไป",
            message: "เครื่องใช้เวลาระบุตำแหน่งนานเกินกำหนด",
            sections: [
              {
                title: "วิธีแก้",
                steps: [
                  "ย้ายไปใกล้หน้าต่างหรือที่โล่ง หากอยู่ในอาคาร",
                  "เปิด Wi-Fi และข้อมูลมือถือ",
                  "ปิดโหมดประหยัดแบตเตอรี่และ VPN ชั่วคราว",
                  'กด "ลองใหม่"',
                ],
              },
            ],
          };

        case "insecure":
          return {
            ...base,
            icon: "mdi-lock-open-alert-outline",
            title: "ต้องเปิดเว็บผ่าน HTTPS",
            message: "เบราว์เซอร์อนุญาตให้ใช้ตำแหน่งเฉพาะเว็บที่ขึ้นต้นด้วย https:// เท่านั้น",
            sections: [
              {
                title: "วิธีแก้",
                steps: [
                  'กด "เปิดแบบ HTTPS" ด้านล่าง',
                  "หากเข้าจากบุ๊กมาร์กเดิม ให้แก้บุ๊กมาร์กเป็น https://",
                  "หากยังเข้าไม่ได้ กรุณาติดต่อผู้ดูแลระบบ",
                ],
              },
            ],
            retryLabel: "เปิดแบบ HTTPS",
            retryAction: "https",
          };

        case "unsupported":
          return {
            ...base,
            icon: "mdi-web-off",
            title: "เบราว์เซอร์นี้ไม่รองรับการระบุตำแหน่ง",
            message: `${name} บนอุปกรณ์นี้ไม่รองรับการระบุตำแหน่ง`,
            sections: [
              {
                title: "วิธีแก้",
                steps: [
                  "อัปเดตเบราว์เซอร์เป็นเวอร์ชันล่าสุด",
                  "หรือเปิดเว็บนี้ด้วย Google Chrome, Safari หรือ Microsoft Edge",
                ],
              },
            ],
            showRetry: false,
          };

        case "inapp":
          return {
            ...base,
            icon: "mdi-cellphone-link",
            color: "#ffbe5c",
            title: `ใช้ตำแหน่งในแอป ${name} ไม่ได้`,
            message: "เบราว์เซอร์ในแอปแชทหรือโซเชียลมักไม่อนุญาตให้เว็บใช้ตำแหน่ง กรุณาเปิดเว็บนี้ในเบราว์เซอร์ของเครื่อง",
            sections: [
              {
                title: "วิธีเปิดในเบราว์เซอร์",
                steps: [
                  "แตะเมนู ⋮ หรือ ⋯ ที่มุมขวาบน",
                  `เลือก "เปิดในเบราว์เซอร์" (Open in browser) หรือ "เปิดใน ${env.os === "ios" ? "Safari" : "Chrome"}"`,
                  'หรือกด "คัดลอกลิงก์" แล้วนำไปวางในเบราว์เซอร์',
                ],
              },
            ],
            showRetry: false,
            showCopyLink: true,
          };

        case "invalid":
          return {
            ...base,
            title: "พิกัดที่ได้รับไม่ถูกต้อง",
            message: "เครื่องส่งพิกัดที่ผิดปกติกลับมา",
            sections: [
              {
                title: "วิธีแก้",
                steps: [
                  "ปิดแอปหรือส่วนขยายที่จำลองตำแหน่ง (Mock location / Fake GPS)",
                  "ปิดแล้วเปิดบริการตำแหน่งของเครื่องใหม่",
                  'กด "ลองใหม่"',
                ],
              },
            ],
          };

        case "map_load_failed":
          return {
            ...base,
            icon: "mdi-map-search-outline",
            color: "#ffbe5c",
            title: "โหลดแผนที่ไม่สำเร็จ",
            message: "ระบุตำแหน่งได้แล้วและยังเช็คอินได้ตามปกติ แต่แสดงแผนที่ไม่ได้",
            sections: [
              {
                title: "วิธีแก้",
                steps: [
                  "ตรวจสอบการเชื่อมต่ออินเทอร์เน็ต",
                  "ปิดโปรแกรมบล็อกโฆษณา (Ad blocker) สำหรับเว็บนี้",
                  'กด "รีเฟรชหน้า"',
                ],
              },
            ],
            retryLabel: "รีเฟรชหน้า",
            retryAction: "reload",
          };

        default:
          return {
            ...base,
            title: "ระบุตำแหน่งไม่สำเร็จ",
            message: "เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุระหว่างระบุตำแหน่ง",
            sections: [
              {
                title: "วิธีแก้",
                steps: [
                  "ตรวจสอบว่าเปิดบริการตำแหน่งของเครื่องแล้ว",
                  "โหลดหน้านี้ใหม่",
                  "หากยังไม่ได้ กรุณาติดต่อผู้ดูแลระบบ",
                ],
              },
            ],
          };
      }
    },

    // ใช้ตอนกด Check In: ขอพิกัดสด ถ้าไม่ได้ ใช้พิกัดล่าสุดที่ไม่เก่าเกินไป
    async resolveCheckInLocation() {
      const coords = await this.fetchCurrentLocation({ silent: true, fresh: true });
      if (coords) return coords;

      const isRecent =
        this.isValidCoords(this.location_lat, this.location_lng) &&
        this.location_updated_at !== null &&
        Date.now() - this.location_updated_at <= LOCATION_MAX_AGE_FOR_CHECKIN_MS;

      if (isRecent) {
        return { lat: this.location_lat, lng: this.location_lng };
      }
      return null;
    },

    // โหลด Google Maps + สร้างแผนที่ (กันเรียกซ้อน)
    setupMap() {
      if (this.mapSetupPromise) return this.mapSetupPromise;

      this.mapSetupPromise = (async () => {
        if (!this.loaderInstance) {
          this.loaderInstance = new Loader({
            apiKey: "AIzaSyBi65wGqm0gq3E3gKUK7DQp99rIKiVYEmc",
            version: "weekly",
            libraries: ["places"],
          });
        }

        try {
          await this.loaderInstance.load();
          this.mapLoadFailed = false;
        } catch (err) {
          this.mapLoadFailed = true;
          return false;
        }

        const mapElement = await this.waitForElement("map", 5000);
        if (!mapElement) {
          return false;
        }

        if (!this.map || this.map.getDiv() !== mapElement) {
          if (this.marker) {
            this.marker.setMap(null);
          }
          this.marker = null;

          const center = this.isValidCoords(this.location_lat, this.location_lng)
            ? { lat: this.location_lat, lng: this.location_lng }
            : DEFAULT_LAT_LNG;

          this.map = new google.maps.Map(mapElement, {
            center,
            zoom: 13,
          });
        }
        return true;
      })().finally(() => {
        this.mapSetupPromise = null;
      });

      return this.mapSetupPromise;
    },

    updateMapView() {
      if (!this.map || !this.isValidCoords(this.location_lat, this.location_lng)) return;
      this.map.setCenter({ lat: this.location_lat, lng: this.location_lng });
      this.updateMarkerPosition(this.location_lat, this.location_lng);
    },

    async initMap(options) {
      // setInterval บางเบราว์เซอร์ส่ง argument แปลกๆ มา จึงเช็ค type ก่อน
      const silent = !!(options && typeof options === "object" && options.silent);

      // ไม่มีสิทธิ์ section นี้ หรืออยู่สถานะ checkout (ใช้พิกัดจาก DB) ไม่ต้องขอพิกัด
      if (!this.sec_acc_time_attendance || this.statusActivity === "checkout") {
        return;
      }

      // ขอพิกัดคู่ขนานกับการโหลดแผนที่ แผนที่พังก็ยังได้พิกัด
      const locationPromise = this.fetchCurrentLocation({ silent });
      await this.setupMap();
      const coords = await locationPromise;
      this.updateMapView();

      // แจ้งแผนที่โหลดไม่ได้เฉพาะเมื่อได้พิกัดแล้ว (ถ้าพิกัดพัง popup ของพิกัดสำคัญกว่า) และแจ้งครั้งเดียว
      if (this.mapLoadFailed && coords && !silent && !this.mapErrorShown) {
        this.mapErrorShown = true;
        this.showLocationDialog("map_load_failed");
      }
    },
    waitForElement(id, timeoutMs) {
      return new Promise((resolve) => {
        const start = Date.now();
        const check = () => {
          const el = document.getElementById(id);
          if (el) {
            resolve(el);
          } else if (Date.now() - start > timeoutMs) {
            resolve(null);
          } else {
            requestAnimationFrame(check);
          }
        };
        check();
      });
    },

    updateMarkerPosition(lat, lng) {
      const position = { lat, lng };

      if (this.marker && this.marker.getMap() === this.map) {
        // มี marker อยู่แล้ว แค่ย้ายตำแหน่ง ไม่ต้องสร้างใหม่
        this.marker.setPosition(position);
      } else {
        if (this.marker) {
          this.marker.setMap(null);
        }
        this.marker = new google.maps.Marker({
          position,
          map: this.map,
          title: "You are here",
          icon: {
            // [LOCATION FIX] ใช้ https กัน mixed content
            url: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",
          },
        });
      }
    },
    updateTime() {
      ///โหดล เเบบเรียวทาม
      const now = new Date();

      // แปลงเวลาตาม 12-hour format (AM/PM)
      const hours = now.getHours();
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const period = hours >= 12 ? "PM" : "AM"; // AM/PM
      const formattedHours = hours % 12 === 0 ? 12 : hours % 12;

      // convert 0 to 12 for 12-hour format
      this.currentTime = `${formattedHours}:${minutes} ${period}`;

      if (this.statusActivity == "checkin") {
        this.loadDataChecKIN();
      } else if (this.statusActivity == "checkout") {
        if (this.dataActivivty) {
          this.loadDataChecKOut(this.dataActivivty);
        }
      } else {
        return;
      }
    },
    async loadLeave() {

      var data_leave_set = {
        date_now: new Date().toISOString().split("T")[0],
        company_id: Number(localStorage.getItem(server.COMPANYID)),
      };
      const res_leave = await api.getToDashboard({ params: data_leave_set });
      var dataleave = Object.values(
        res_leave.data.reduce((acc, item) => {
          // สร้าง key โดยไม่เอา amount
          const key = `${item.userid}-${item.strc_date}`;

          if (!acc[key]) {
            acc[key] = { ...item };
          } else {
            acc[key].amount = Number(item.amount) + Number(acc[key].amount);
          }

          return acc;
        }, {})
      );
      this.leave_list = dataleave;
      this.leave_number = dataleave.length;

      for (const [index, item] of this.leave_list.entries()) {
        if (item.image_profile != "" && item.image_profile != null) {
          item.image_profile = imageUrl + "/" + item.image_profile;
        } else {
          item.image_profile = "";
        }

        var leave_day = 0;
        var leave_hours = 0;

        leave_day = Math.floor(Number(item.amount) / 60 / 8);
        leave_hours = Number(Number(item.amount) / 60) - leave_day * 8;

        if (leave_day == 0) {
          if (leave_hours == 0) {
            item.description = ``;
          } else if (leave_hours == 4) {
            item.description = item.description = `Half Day`;
          } else if (leave_hours == 8) {
            item.description = item.description = `Full Day`;
          } else {
            item.description = item.description = `${leave_hours} Hours`;
          }
        } else {
          if (leave_hours == 0) {
            if (leave_day > 1) {
              item.description = `${leave_day} Day`;
            } else {
              item.description = `Full Day`;
            }
          } else {
            item.description = item.description = `${leave_day} Day ${leave_hours} Hours`;
          }
        }
      }
      // this.leave_list = []
    },
    async loadActivityData() {
      const resCheckInData = await api.getCheckinDateWeb(
        localStorage.getItem(server.USER_ID),
      );


      if (resCheckInData.data.length > 0) {
        resCheckInData.data[0].checkindate = moment(
          resCheckInData.data[0].checkindate
        )
          .subtract(7, "hours")
          .format("YYYY-MM-DD HH:mm:ss");

        resCheckInData.data[0].checkInDate_Date = resCheckInData.data[0].checkindate;

        this.statusActivity = "checkout";

        // [LOCATION FIX] API อาจส่งพิกัดเป็น string/undefined แปลงให้เป็น number หรือ null
        this.location_lng = this.toCoord(resCheckInData.data[0].location_lng);
        this.location_lat = this.toCoord(resCheckInData.data[0].location_lat);

        this.update_id = resCheckInData.data[0].id;
        this.dataActivivty = resCheckInData.data[0];

        var checkinDate = new Date(resCheckInData.data[0].checkInDate_Date);
        //เซต เวลา checkin
        const formattedStartTime = checkinDate.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        });
        this.checkindate = `${formattedStartTime}`;

        // เพิ่มเวลา 9 ชั่วโมง
        const expectTime = new Date(checkinDate.getTime() + 9 * 60 * 60 * 1000); // เพิ่ม 9 ชั่วโมง (9 * 60 * 60 * 1000 ms)
        const formattedExpectDate = expectTime.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
        });
        const formattedExpectTime = expectTime.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        });

        // สร้างค่า expecttime
        this.expecttime = `${formattedExpectTime}`;

        this.loadDataChecKOut(this.dataActivivty);
      } else {
        this.location_lng = null;
        this.location_lat = null;
        this.statusActivity = "checkin";
        this.dataActivivty = {};
        this.loadDataChecKIN();
      }
      await this.$nextTick();
      this.initMap();
    },
    loadDataChecKIN() {
      const now = new Date();

      //checkin datetime
      const formattedStartDate = now.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });
      const formattedStartTime = now.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
      this.checkindate = `${formattedStartDate}, ${formattedStartTime}`;

      // เพิ่มเวลา 9 ชั่วโมง
      const expectTime = new Date(now.getTime() + 9 * 60 * 60 * 1000); // เพิ่ม 9 ชั่วโมง (9 * 60 * 60 * 1000 ms)
      const formattedExpectDate = expectTime.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });
      const formattedExpectTime = expectTime.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });

      // สร้างค่า expecttime
      this.expecttime = `${formattedExpectTime}`;

      //date show
      const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        weekday: "short",
      };

      // ใช้ Intl.DateTimeFormat เพื่อให้แน่ใจว่าการแสดงผลถูกต้อง
      const formatter = new Intl.DateTimeFormat("en-US", options);
      const parts = formatter.formatToParts(now);

      // ดึงค่าจาก parts เพื่อเรียงข้อมูลใหม่
      let weekday = "";
      let month = "";
      let day = "";
      let year = "";

      parts.forEach(({ type, value }) => {
        if (type === "weekday") weekday = value;
        if (type === "month") month = value;
        if (type === "day") day = value;
        if (type === "year") year = value;
      });

      const finalFormattedDate = `${month} ${day}, ${year} (${weekday})`;
      this.datenow_show = finalFormattedDate;
    },
    loadDataChecKOut(data) {
      // this.checkindate

      //เซต datetime show
      const now = new Date();

      //date show
      const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        weekday: "short",
      };

      // ใช้ Intl.DateTimeFormat เพื่อให้แน่ใจว่าการแสดงผลถูกต้อง
      const formatter = new Intl.DateTimeFormat("en-US", options);
      const parts = formatter.formatToParts(now);

      // ดึงค่าจาก parts เพื่อเรียงข้อมูลใหม่
      let weekday = "";
      let month = "";
      let day = "";
      let year = "";

      parts.forEach(({ type, value }) => {
        if (type === "weekday") weekday = value;
        if (type === "month") month = value;
        if (type === "day") day = value;
        if (type === "year") year = value;
      });

      const finalFormattedDate = `${month} ${day}, ${year} (${weekday})`;
      this.datenow_show = finalFormattedDate;

      //คำนวณเวลา
      var checkinDate = new Date(data.checkInDate_Date);
      var checkoutDate = now;

      // คำนวณความแตกต่างระหว่างเวลาทั้งสอง (ในมิลลิวินาที)
      var timeDifference = checkoutDate - checkinDate;

      // แปลงมิลลิวินาทีเป็นนาที
      var timeDifferenceInMinutes = timeDifference / (1000 * 60);

      // ตรวจสอบและลดเวลาตามเงื่อนไข
      if (timeDifferenceInMinutes >= 300) {
        timeDifferenceInMinutes -= 60; // ลด 60 นาที หากเวลามากกว่า 300 นาที
      }

      // ตรวจสอบให้เวลามากสุดไม่เกิน 480 นาที
      if (timeDifferenceInMinutes > 480) {
        timeDifferenceInMinutes = 480; // จำกัดเวลาที่ 480 นาที
      }
      this.duration = Math.floor(timeDifferenceInMinutes);
      const hours = Math.floor(timeDifferenceInMinutes / 60); // คำนวณชั่วโมง
      const minutes = Math.floor(timeDifferenceInMinutes % 60);

      const formattedTimeDifference = `${hours}h ${minutes}m`;
      this.worker_time = formattedTimeDifference;
    },
    async loadEmpdata() {
      const res_emp = await api.getAccountByidMenu(
        localStorage.getItem(server.USER_ID),
      );

      this.th_name = res_emp.data[0].name;
      this.eng_name = res_emp.data[0].eng_name;
    },
    async loadQuota() {
      const res_quota = await api.getListByUserDashboard(
        localStorage.getItem(server.USER_ID),
      );
      if (res_quota.data && res_quota.data.length > 0) {
        var canuse_leave = 0;
        canuse_leave = Number(res_quota.data[0].leave_can_use);
        this.vacation_day = Math.floor(canuse_leave);
        this.vacation_hours = (canuse_leave - this.vacation_day) * 8;
      } else {
        this.vacation_day = 0;
        this.vacation_hours = 0;
      }
    },
    async loadleaveHistory() {
      const res_leave_history = await api.getListHistoryAll(
        localStorage.getItem(server.USER_ID),
      );
      if (res_leave_history.data && res_leave_history.data.length > 0) {
        const filteredData = res_leave_history.data.filter(
          (item) => Number(item.status) === 1 || Number(item.status) === 2,
        );
        this.pending_cont = filteredData.length;
        this.leaveHistoryAll = res_leave_history.data;
      } else {
        this.pending_cont = 0;
        this.leaveHistoryAll = [];
      }
    },
    async loadleaveApprove() {
      var res_leave_approve = [];
      if (localStorage.getItem("dtime_role") == "ADMIN") {
        res_leave_approve = await api.getListAdminAll(
          localStorage.getItem(server.COMPANYID)
        );
      } else {
        res_leave_approve = await api.getListApprove(
          localStorage.getItem(server.USER_ID),
        );

      }
      // นับรายการรออนุมัติทั้งหมด (ใช้กับ badge "x awaiting review")
      this.approvePendingTotal = (res_leave_approve.data || []).filter(
        (item) => item.status_name !== "Approved" && item.status_name !== "Rejected",
      ).length;

      const datalist_leave = res_leave_approve.data.slice(0, 5);
      for (const [index, item] of datalist_leave.entries()) {
        if (item.leave_type == "Sick Leave") {
          item.leave_type = "Sick";
        } else if (item.leave_type == "Vacation Leave") {
          item.leave_type = "Vacation";
        }
        var leave_day = 0;
        var leave_hours = 0;

        leave_day = Math.floor(Number(item.hours_amount) / 8);
        leave_hours = Number(item.hours_amount) - leave_day * 8;

        if (leave_day == 0) {
          if (leave_hours == 0) {
            item.description = `${item.data_date}`;
          } else {
            item.description = item.description = `${item.data_date} (${leave_hours} hours)`;
          }
        } else {
          if (leave_hours == 0) {
            item.description = `${item.data_date} (${leave_day} day)`;
          } else {
            item.description = item.description = `${item.data_date} (${leave_day} day ${leave_hours} hours)`;
          }
        }
        if (item.image != "" && item.image != null) {
          item.image_profile = imageUrl + "/" + item.image;
        } else {
          item.image_profile = "";
        }
      }
      console.log(datalist_leave)
      this.leaveApprove_list = datalist_leave;
    },
    async goToLeaveHistory() {
      this.$router.push("/my-time-off");
    },
    async goToLeaveHistoryById(id, status) {
      if (status == 1) {
        this.$router.push(`/leave-request-edit/${id}`);
      } else {
        this.$router.push(`/leave-request-waiting/${id}/dashboard`);
      }
    },
    async goToLeaveApprove() {
      // เปลี่ยน URL หรือทำการนำทางที่ต้องการ
      this.$router.push("/approver-time-off"); // หากคุณใช้ Vue Router
    },
    async goToLeaveApproveById(id, user_id, status) {
      // เปลี่ยน URL หรือทำการนำทางที่ต้องการ
      if (Number(status) == 3 || Number(status) == 4) {
        this.$router.push(`/leave-request-waiting/${id}/leave`);
      } else {
        this.$router.push(`/approve-leave-confirm/${id}/${user_id}`);
      }
      // หรือ window.location.href = 'URL ที่ต้องการ'; // หากคุณต้องการเปลี่ยนไปยัง URL อื่น
    },
    CheckInOut() {
      this.dialogcCheckIn = true;
    },
    closecheckInOu() {
      this.dialogcCheckIn = false;
    },
    async checkInOutConfirm() {
      this.dialogcCheckIn = false;

      // สร้างรูปแบบวันที่ตามที่ต้องการ
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // เดือนเริ่มจาก 0, ดังนั้นต้อง +1
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");

      // สร้างวันที่ในรูปแบบ yyyy:mm:dd HH:MM:00
      const formattedDate = `${year}:${month}:${day} ${hours}:${minutes}:00`;

      if (this.statusActivity == "checkout") {
        var dataUpdate = {};

        dataUpdate.chargeType = "";
        dataUpdate.isCheckedOut = true;
        dataUpdate.jobTitleId = 0;
        dataUpdate.customerId = 0;
        dataUpdate.prospect = "";
        dataUpdate.detail = "";
        dataUpdate.duration = this.duration;
        dataUpdate.addby = "W";

        var input = formattedDate;
        const [date, time] = input.split(' ');
        const fixedDate = date.replace(/:/g, '-');

        const result = `${fixedDate} ${time}`;
        dataUpdate.checkOutDate = result;

        this.$showLoader();
        const res_updateAct = await api.updateActivity(
          this.update_id,
          dataUpdate,
        );

        if (res_updateAct.status == 200 || res_updateAct.status == 201) {
          this.datenow_show = null;
          this.timenow_show = null;
          this.expecttime = null;
          this.checkindate = null;
          await this.loadActivityData();
          await this.loadEmpdata();
          await this.loadQuota();
          await this.loadleaveHistory();
          await this.loadleaveApprove();
          this.$hideLoader();

          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "Information successfully saved",
            "text-h5 green--text text-center",
          );
          return;
        } else {
          this.$hideLoader();
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center",
          );
          return;
        }
      } else {

        // [LOCATION FIX] เช็คสิทธิ์แบบปลอดภัย (ไม่ throw บน Safari รุ่นเก่า)
        if (await this.isGeoPermissionDenied()) {
          this.handleLocationError("denied", false);
          return; //หยุดทำงานต่อ
        }

        // [LOCATION FIX] ขอพิกัดสดก่อนบันทึก ถ้าไม่ได้ห้ามส่ง null ไป backend
        this.$showLoader();
        const coords = await this.resolveCheckInLocation();
        if (!coords) {
          this.$hideLoader();
          // แสดง popup ตามสาเหตุจริง (สิทธิ์, GPS ปิด, timeout ฯลฯ)
          this.showLocationDialog(this.locationErrorReason || "unknown");
          return;
        }

        var addItem = {};
        addItem.location_lat = coords.lat;
        addItem.location_lng = coords.lng;
        addItem.chargeType = "";
        addItem.company_id = Number(localStorage.getItem(server.COMPANYID));
        addItem.isCheckedOut = 0;
        addItem.userId = Number(localStorage.getItem(server.USER_ID));
        addItem.departmentId = Number(
          localStorage.getItem(server.DEPARTMENT_ID),
        );
        addItem.jobTitleId = 0;
        addItem.customerId = 0;
        addItem.prospect = "";
        addItem.detail = "";
        addItem.addby = "W";
        addItem.check_auto = 0;
        addItem.status = "A";

        var input = formattedDate;
        const [date, time] = input.split(' ');
        const fixedDate = date.replace(/:/g, '-');

        const result = `${fixedDate} ${time}`;
        addItem.checkInDate = result;

        const res_addAct = await api.createActivityCheckin(addItem);
        if (res_addAct.status == 200 || res_addAct.status == 201) {
          this.datenow_show = null;
          this.timenow_show = null;
          this.expecttime = null;
          this.checkindate = null;
          await this.loadActivityData();
          await this.loadEmpdata();
          await this.loadQuota();
          await this.loadleaveHistory();
          await this.loadleaveApprove();
          this.$hideLoader();

          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "Information successfully saved",
            "text-h5 green--text text-center",
          );
          return;
        } else {
          this.$hideLoader();
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center",
          );
          return;
        }
      }
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
